// extracted by mini-css-extract-plugin
export var active = "_97-b";
export var activeIndicator = "_97-6";
export var animate = "_97-a";
export var disabled = "_97-c";
export var flat = "_97-1";
export var fullWidth = "_97-3";
export var lg = "_97-9";
export var md = "_97-8";
export var redoButtonTabGroup = "_97-0";
export var sm = "_97-7";
export var tabButton = "_97-4";
export var tabButtonsContainer = "_97-2";
export var xs = "_97-5";